import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import DatePicker from 'react-datepicker2';
import moment from 'moment-jalaali';
// import moment from "moment-jalaali";
// import faIR from 'rsuite/locales/fa_IR';
// import format from 'date-fns/format';
// import farsi from 'date-fns/locale/fa-IR'

const FiscalYearIndex = () => {

    //#region Const
    // moment.locale("fa", faIR);
    // moment.loadPersian();
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [FiscalYearList, setFiscalYearList] = useState([]);
    const [Id, setId] = useState(0);
    const [Title, setTitle] = useState('');
    const [BeginDate, setBeginDate] = useState(new Date());
    const [EndDate, setEndDate] = useState(null);
    const [IsActive, setIsActive] = useState(true);
    const [ShowModal, setShowModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)

    //#endregion

    //#region Handlers

    const BeginDate_Change = e => {
        // var m = Intl.DateTimeFormat('fa-IR').format(e);
        // console.dir(m)
        // setBeginDate(e)
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    //#endregion  


    //#region Methods

    const GetAll = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/FiscalYear/GetAll', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            EndDate: result[i].endDate,
                            BeginDate: result[i].beginDate,
                            IsActive: result[i].isActive,

                        })
                    }
                    setFiscalYearList(tmp)
                })
        )
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };


    const Reset = () => {
        setTitle("");
        setId(0);
        setIsActive(true);
        setBeginDate(null);
        setEndDate(null);
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": Id,
                "Title": Title,
                "IsActive": IsActive ? 1 : 0,
                "BeginDate": moment(BeginDate.format()).format('jYYYY/jMM/jDD'),
                "EndDate": moment(EndDate.format()).format('jYYYY/jMM/jDD'),
            },
            url: General.ApiRoute() + "/FiscalYear/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        GetAll();
                        Reset();
                        setShowModal(false);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(10, id, title);
    }

    const ShowEdit = (Id) => {
        Reset();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/FiscalYear/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setIsActive(result.isActive == 0 ? false : true);
                    setBeginDate(moment(result.beginDate, 'jYYYY/jMM/jDD'));
                    setEndDate(moment(result.endDate, 'jYYYY/jMM/jDD'));
                })
        )
    }

    const ShowNew = () => {
        setShowModal(true);
        Reset();
    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 10);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        GetAll();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    useEffect(() => {
        CheckPermission();
        document.title = "سال مالی";
    }, [])
    //#endregion







    return (

        <Layout title="سال مالی">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white h-10 ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>
                           
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    height={420}
                                    data={FiscalYearList.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                    loading={loading}

                                >
                                    <rsuite.Table.Column className="w-10p" align="center" fixed sortable>
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Title" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>تاریخ شروع</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="BeginDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                        <rsuite.Table.HeaderCell>ناریخ پایان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="EndDate" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText width={100} resizable>
                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column width={60} fixed="right" >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.Id, rowData.Title)}>حذف</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="md" backdrop="static" keyboard={false} >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b>تعریف سال مالی  </b></Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                <rsuite.Input value={Title} onChange={(e) => setTitle(e)} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={BeginDate == "" ? 'text-danger' : 'hide'} />  <label>تاریخ شروع</label>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <BiIcon.BiSolidStar className={EndDate == "" ? 'text-danger' : 'hide'} />  <label>تاریخ پایان</label>
                                <DatePicker className="rs-input" isGregorian={false} timePicker={false}  icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)}  checked={IsActive} value={IsActive} /> &nbsp; فعال می باشد

                            </rsuite.Col>


                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Delete ref={DeleteRef} onSubmit={GetAll} />
        </Layout >


    )
}

export default FiscalYearIndex;